export async function main (platform, hostname, factory) {
  const api = create(platform, hostname, factory)

  if (!IS_BROWSER) {
    try {
      const defaults = [{ name: 'Categories' }, { name: 'Brands' }, { name: 'Tags' }]

      for (const d of defaults) {
        await api.ecom.taxonomies.upsert(d, {
          where: `taxonomy.name = ?`,
          whereArgs: [d.name],
        })
      }
    } catch (err) {
      if (![401, 409].includes(err.data.status)) {
        console.error(err)
      }
    }

    try {
      const defaultPriceKinds = [{ name: 'Retail Price' }]

      for (const d of defaultPriceKinds) {
        await api.ecom.priceKinds.upsert(d, {
          where: `priceKind.name = ?`,
          whereArgs: [d.name],
        })
      }
    } catch (err) {
      if (![401, 409].includes(err.data.status)) {
        console.error(err)
      }
    }

    try {
      const defaultCurrencies = [{ name: 'Great British Pound', code: 'GBP', symbol: '£' }]

      for (const d of defaultCurrencies) {
        await api.ecom.currencies.upsert(d, {
          where: `currency.name = ?`,
          whereArgs: [d.name],
        })
      }
    } catch (err) {
      if (![401, 409].includes(err.data.status)) {
        console.error(err)
      }
    }
  }

  platform.api.ecom = api.ecom
}

const routes = [
  {
    name: 'Dashboard',
    icon: 'paid',
    route: '/cms/ecom/dashboard',
    svg: `
      <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
        <path stroke-linecap="round" stroke-linejoin="round" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
      </svg>
    `,
  },
  {
    name: 'Product Management',
    icon: 'production_quantity_limits',
    route: '/cms/ecom/products-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
    `,
  },
  {
    name: 'Attribute Management',
    icon: 'edit_attributes',
    route: '/cms/ecom/attributes',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
    </svg>
    `,
  },
  {
    name: 'Category Management',
    icon: 'category',
    route: '/cms/ecom/category-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
    q <path stroke-linecap="round" stroke-linejoin="round" d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
    </svg>
    `,
  },
  {
    name: 'Brands Management',
    icon: 'business',
    route: '/cms/ecom/brands-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
    </svg>
    `,
  },
  {
    name: 'Tags Management',
    icon: 'local_offer',
    route: '/cms/ecom/tags-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
    </svg>
    `,
  },
  {
    name: 'Currency Management',
    icon: 'euro',
    route: '/cms/ecom/currency-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    `,
  },
  {
    name: 'Prices Management',
    icon: 'price_change',
    route: '/cms/ecom/prices-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
    `,
  },
  {
    name: 'Shipping Option Management',
    icon: 'price_change',
    route: '/cms/ecom/shipping-option-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
    `,
  },
  {
    name: 'Voucher Management',
    icon: 'price_change',
    route: '/cms/ecom/voucher-management',
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
    </svg>
    `,
  },
  {
    name: 'Orders Management',
    icon: 'shopping_bag',
    route: '/cms/ecom/order-management',
  },
]

export function create (platform, hostname, factory) {
  const api = {
    ecom: {
      basket: {
        async summary (data) {
          const res = await platform.fetch(`https://${hostname}/api/ecom/basket/summary`, {
            method: 'POST',
            body: JSON.stringify(data),
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/basket/summary`)

          return res.json()
        },
        async shippingOptions (data) {
          const res = await platform.fetch(`https://${hostname}/api/ecom/shipping-options/basket`, {
            method: 'POST',
            body: JSON.stringify(data),
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/shipping-options/basket`)

          return res.json()
        },
        async createOrder (data) {
          if (!data.gateway) {
            throw new Error('A gateway must be specified')
          }

          let orderId = ''
          let success = ''
          let cancel = ''

          if (data.orderId) {
            orderId = `&order-id=${data.orderId}`
          }

          if (data.success) {
            success = `&success=${data.success}`
          }

          if (data.cancel) {
            cancel = `&cancel=${data.cancel}`
          }

          const res = await platform.fetch(`https://${hostname}/api/ecom/orders/basket?gateway=${data.gateway}${orderId}${success}${cancel}`, {
            method: 'POST',
            body: JSON.stringify(data),
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/orders/basket`)

          return res.json()
        },
      },
      bidLogs: factory.createRoute(platform, hostname, '/api/ecom/bid-logs'),
      bids: {
        async won () {
          const res = await platform.fetch(`https://${hostname}/api/ecom/lots/person/won`, {
            method: 'GET',
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/lots/person/won`)

          return res.json()
        },
      },
      brands: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entries', options => {
        if (!options) {
          options = {}
        }

        options.where = options.where ? `(${options.where}) AND taxonomy.name = ?` : 'taxonomy.name = ?'
        options.whereArgs = options.whereArgs || []
        options.whereArgs.push('Brands')
      }),
      categories: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entries', options => {
        if (!options) {
          options = {}
        }

        options.where = options.where ? `(${options.where}) AND taxonomy.name = ?` : 'taxonomy.name = ?'
        options.whereArgs = options.whereArgs || []
        options.whereArgs.push('Categories')
      }),
      tags: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entries', options => {
        if (!options) {
          options = {}
        }

        options.where = options.where ? `(${options.where}) AND taxonomy.name = ?` : 'taxonomy.name = ?'
        options.whereArgs = options.whereArgs || []
        options.whereArgs.push('Tags')
      }),
      products: factory.createRoute(platform, hostname, '/api/ecom/products'),
      productImages: factory.createRoute(platform, hostname, '/api/ecom/product-images'),
      productAttributes: factory.createRoute(platform, hostname, '/api/ecom/product-attributes'),
      productAttributeTriggers: factory.createRoute(platform, hostname, '/api/ecom/product-attribute-triggers'),
      productPrices: factory.createRoute(platform, hostname, '/api/ecom/product-prices'),
      consignors: factory.createRoute(platform, hostname, '/api/cms/consignors'),
      attributes: factory.createRoute(platform, hostname, '/api/ecom/attributes'),
      orders: {
        ...factory.createRoute(platform, hostname, '/api/ecom/orders'),
        async capturePayPal (orderId, emailTemplateId) {
          const res = await platform.fetch(`https://${hostname}/api/ecom/orders/${orderId}/paypal/capture?email-template-id=${emailTemplateId || ''}`, {
            method: 'POST',
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/orders/${orderId}/paypal/capture?email-template-id=${emailTemplateId || ''}`)

          return res.json()
        },
        async findInvoice (invoiceNumber) {
          const res = await platform.fetch(`https://${hostname}/api/ecom/orders/invoice/${invoiceNumber}`, {
            method: 'GET',
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/orders/invoice/${invoiceNumber}`)

          return res.json()
        },
        async sendEmail (orderId, emailTemplateId) {
          const res = await platform.fetch(`https://${hostname}/api/ecom/orders/${orderId}/email?email-template-id=${emailTemplateId}`, {
            method: 'POST',
          })

          await factory.maybeThrowAPIError(res, `/api/ecom/orders/${orderId}/email`)

          return res.json()
        },
      },
      orderItems: factory.createRoute(platform, hostname, '/api/ecom/order-items'),
      currencies: factory.createRoute(platform, hostname, '/api/ecom/currencies'),
      priceKinds: factory.createRoute(platform, hostname, '/api/ecom/price-kinds'),
      shippingOptions: factory.createRoute(platform, hostname, '/api/ecom/shipping-options'),
      taxonomies: factory.createRoute(platform, hostname, '/api/ecom/taxonomies'),
      taxonomyEntries: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entries'),
      taxonomyEntryImages: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entry-images'),
      taxonomyEntryProducts: factory.createRoute(platform, hostname, '/api/ecom/taxonomy-entry-products'),
      vouchers: factory.createRoute(platform, hostname, '/api/ecom/vouchers'),
      routes,
    },
  }

  return api
}
